import dayjs from 'dayjs';

const Session = class Session {
    constructor() {
        this.id = null;
        this.title = '';
        this.description = '';
        this.isLocked = false;
        this.isArchived = false;
        this.startedAt = null;
        this.instructorId = null;
        this.tags = null;
        this.video = null;
        this.theme = null;
        this.videoName = null;
        this.sessionLink = null;

        this.date = dayjs().format('YYYY-MM-DD');
        this.time = dayjs()
            .add(1, 'hour')
            .format('HH:mm');
        this.type = null;

        this.todayVote = {
            isCompleted: false,
            before: null,
            after: null
        };
        this.poster = null;
        this.poster_name = null;
        this.assignedToAll = false;
        this.isSuggested = false;
        this.startTime = null;
        this.endTime = null;

        this.meetingDetails = {
            join_before_host: true,
            duration: 40,
            jbh_time: 5,
            waiting_room: false
        };

        this.check_in_duration = 0;

        this.audience = {
            businessIds: [],
            users: []
        };
        this.feedLabel = '';
    }
};

export default Session;
